// src/pages/CardNotExist.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header"; // Fixed: Changed from ./Header to ../components/Header
import ResponsiveNoCardFound from "../components/ResponsiveNoCardFound"; // Fixed: Changed from ./ResponsiveNoCardFound to ../components/ResponsiveNoCardFound

const CardNotExist = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <Header />

      <div className="flex-1 flex items-center justify-center">
        <div
          className="
            w-[97vw]
            h-[90vh]
            flex
            flex-col
            items-center
            justify-center
            rounded
            shadow
            bg-no-repeat
            bg-center
            bg-contain
            relative
          "
        >
          <ResponsiveNoCardFound /> {/* Integrated the responsive image component */}
          {/* Overlay for readability (optional) */}
          <div className="absolute inset-0 bg-white bg-opacity-70 backdrop-blur-xs" />

          <div className="relative z-10 text-center p-6 max-w-xl">
            <h2 className="text-2xl font-semibold text-red-600 mb-4">
              Няма намерена картичка
            </h2>
            <p className="text-gray-700 mb-6">
              Картичката която се опитвате да достъпите не същесвува.
              Моля сканирайте отново баркода от картичката или се обърнете
              към търговския обект от който сте я закупили.
            </p>
            <button
              onClick={() => navigate("/")}
              className="
                px-4
                py-2
                bg-red-500
                text-white
                rounded
                hover:bg-red-600
              "
            >
              Начало
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardNotExist;